/**
 * Relationship-manager portal shell. Same bar and rail as every other
 * portal; only the modules differ.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/useAuth";
import { managerNav } from "./managerNav";
import { PortalShell } from "./PortalShell";
import { ShellSkeleton } from "./ShellSkeleton";
import { MANAGER_SECTIONS } from "./navSections";

export function ManagerShell() {
  const { data: me, isPending, isError } = useMe();
  const location = useLocation();

  if (isPending) return <ShellSkeleton items={6} />;
  if (isError || !me) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  if (me.role !== "manager") {
    if (me.role === "platform_admin") return <Navigate to="/platform/dashboard" replace />;
    if (me.role === "admin") return <Navigate to="/admin/dashboard" replace />;
    if (me.role === "ib") return <Navigate to="/ib/dashboard" replace />;
    return <Navigate to="/trader/dashboard" replace />;
  }

  return <PortalShell nav={managerNav} sections={MANAGER_SECTIONS} supportTo="/manager/clients" />;
}
